/* eslint-disable no-nested-ternary */
import {isNode} from 'hiya-common/src/utils/index'
import {HorseSoundEnum, HorseSoundTypeEnum, StatusEnum} from './interface'
// animsKey 设计给的资源id与真实马的id不对应
export const HorseConst = {
  '1': {
    animsKey: 8,
  },
  '2': {
    animsKey: 6,
  },
  '3': {
    animsKey: 1,
  },
  '4': {
    animsKey: 5,
  },
  '5': {
    animsKey: 2,
  },
  '6': {
    animsKey: 3,
  },
  '7': {
    animsKey: 7,
  },
  '8': {
    animsKey: 4,
  },
}
export type HorseType = keyof typeof HorseConst

export const HorseConstIds = Object.keys(HorseConst) as Array<HorseType>
export const dpi = 2 // window.devicePixelRatio

export const TimeConfig = {
  // 0-560ms马入场等待
  wait: {
    start: 0,
    time: 560,
  },
  // 560ms-720ms赔率进场
  odds: {
    start: 560,
    time: 160,
  },
  horse_run: {
    start: 16 * 1000,
    time: 15 * 1000,
  },
  horse_end: {
    start: 25 * 1000,
    time: 1 * 1000,
  },
  horse_leave: {
    start: 27 * 1000,
    time: 2 * 1000,
  },
}
export const StatusTimeConfig = {
  [StatusEnum.bet]: 25,
  [StatusEnum.preparing]: 5,
  [StatusEnum.showRes]: 5,
}

// 获得千分位的数字 本项目最大示数为99999，5位数，大于这个数目全部使用k为单位
export const getKiloNum = (num: number, toFixed = 0, maxNum = 99999) => {
  // 当maxNum传了，并且num大于maxNum的时候才会去格式化，否则直接返回num
  if (maxNum && num <= maxNum) {
    return num
  }
  const kilo = 1000
  if (num >= kilo) {
    // *1 去掉为0的小数位
    return `${((num / kilo) as any).toFixed(toFixed) * 1}K`
  }
  return `${num}`
}
// 获取中奖结果图片拼装
export const getPrizeValImgSrc = (key) => {
  // 获取不同筹码的图片
  const rewarsPng = require.context('./images/prizeVal', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
export const getChipsImgSrc = (key) => {
  // 获取不同筹码的图片
  const rewarsPng = require.context('./images/chips', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
export enum ResTypeEnum {
  peacock = 1,
  elephant,
  tiger,
}
export const getResTypeImgSrc = (key) => {
  // 获取不同结果类型的图片
  const rewarsPng = require.context('./images/resType', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}

export const getMarkImgSrc = (key) => {
  const rewarsPng = require.context('./images/mark', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
export const getRoundImgSrc = (key) => {
  const rewarsPng = require.context('./images/round', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
export const getHorseImgSrc = (key) => {
  const rewarsPng = require.context('./images/horseAvatar', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
export const sleep = (s) => {
  return new Promise((res) => {
    setTimeout(() => {
      res(null)
    }, s)
  })
}
export const getRoundNo = (roundNo) => {
  return roundNo.toString().slice(8).replace(/^0+/, '')
}
export const playSound = (type: HorseSoundTypeEnum, loop = 0) => {
  const {playing} = window.store.getState().HorseGame
  if (!playing) {
    return
  }
  window.HiyaJSBridge.callHandler('playSound', {
    url: HorseSoundEnum[type],
    loop,
  })
}
export const stopSound = () => {
  window.HiyaJSBridge.callHandler('stopSound')
}
